var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotFoundInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    fill: "white",
    stroke: "#698796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.498 19.0024C23.6226 19.0026 24.543 19.9237 24.543 21.0483C24.5428 22.1761 23.623 23.0931 22.498 23.0933C21.3692 23.0933 20.4523 22.1799 20.4521 21.0483C20.4521 19.9232 21.3701 19.0024 22.498 19.0024ZM22.502 19.5952C21.7024 19.5952 21.0488 20.2488 21.0488 21.0483C21.049 21.8478 21.7025 22.5005 22.502 22.5005C23.3012 22.5002 23.9539 21.8476 23.9541 21.0483C23.9541 20.2489 23.3013 19.5955 22.502 19.5952Z",
    fill: "#698796",
    stroke: "#698796"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2087 15.9106H32.5271L31.9343 16.5034H16.5037V30.7788L17.4197 29.4067L18.5652 27.6899C18.8913 27.211 19.4311 26.9253 19.9978 26.9253C20.4077 26.9254 20.799 27.0726 21.1042 27.3335L20.6833 27.7544C20.4911 27.6057 20.2539 27.5181 19.9978 27.5181C19.6138 27.5181 19.2695 27.7117 19.0603 28.019L19.0583 28.022L16.5886 31.7124L16.5037 31.8394V31.938L15.9109 32.5308V16.2085L15.9167 16.1489C15.9451 16.0142 16.0671 15.9109 16.2087 15.9106Z",
    fill: "#698796",
    stroke: "#698796"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4919 32.3696L35.3787 32.231L29.95 25.6108L30.3689 25.1919L34.6101 30.3501L35.4958 31.4282V20.0649L36.0886 19.4722V35.7905C36.0886 35.954 35.9553 36.0906 35.7869 36.0923H19.4685L20.0613 35.4995H35.4919V32.3696Z",
    fill: "#698796",
    stroke: "#698796"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9634 13.3169C38.1635 13.1168 38.483 13.1168 38.6831 13.3169C38.8831 13.517 38.8831 13.8365 38.6831 14.0366L14.0366 38.6831C13.9387 38.781 13.8114 38.8306 13.6782 38.8306C13.5475 38.8305 13.4199 38.7824 13.3169 38.6831C13.1168 38.483 13.1168 38.1635 13.3169 37.9634L37.9634 13.3169Z",
    fill: "#698796",
    stroke: "#698796"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFoundInactive);
export default __webpack_public_path__ + "static/media/image-not-found-inactive.2a3e27f31b5fe89cb94058f14f6fb807.svg";
export { ForwardRef as ReactComponent };